import React from 'react'

import { AppIconProps } from '@/types/components'

export const DocVaultIcon = (props: AppIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill={props.fill || 'none'}
      width={props.width}
      viewBox='0 0 24 24'
      stroke={props.stroke || 'currentColor'}
      strokeWidth='2'
    >
      <path
        xmlns='http://www.w3.org/2000/svg'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z'
      />
    </svg>
  )
}
